import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pagination: { page: 0, pageSize: 15 },
  sortModel: [{ field: "package_Name", sort: "desc" }], // default sort for Roles
};

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
     resetPage: state => {
      state.pagination.page = 0;
    },
    resetRolesState: state => Object.assign(state, initialState),
  },
});

export const { setPagination, setSortModel, resetRolesState, resetPage } = rolesSlice.actions;
export default rolesSlice.reducer;
